
import AdNormSetsTab from './AdNormSetsTab'
import MainHeader from './MainHeader'
export default { 
  AdNormSetsTab,
  MainHeader
 }
